import { isQuestionGroup, questionLeafRecords } from "../../state/selectors.js";
import { number, pct } from "../../shared/collection.js";

export function questionGroupChildren(items = [], groupId = "", options = {}) {
  const clean = String(groupId || "").trim();
  if (!clean) return [];
  const subjectFilter = options.subjectFilter || "all";
  return questionLeafRecords(items).filter((item) => {
    if (String(item.questionGroupId || "").trim() !== clean) return false;
    if (subjectFilter === "all") return true;
    return item.subject === subjectFilter;
  });
}

export function questionGroupMetrics(children = [], performanceLabel = () => "") {
  const totalLists = children.length;
  const totalQuestions = children.reduce((sum, item) => sum + Math.max(0, number(item.questions)), 0);
  const totalCorrect = children.reduce((sum, item) => sum + Math.max(0, number(item.correct)), 0);
  const accuracy = pct(totalCorrect, totalQuestions);
  return {
    totalLists,
    totalQuestions,
    totalCorrect,
    accuracy,
    performance: performanceLabel(totalCorrect, totalQuestions),
  };
}

export function questionTopLevelItems(items = []) {
  return [...(items || [])].filter((item) => isQuestionGroup(item) || !String(item.questionGroupId || "").trim());
}
